const translations = {
    connectFirst: 'Connect to John Deere on the Account page to import data',
    importFromJohnDeere: 'Get My John Deere Data',
    title: 'Import Data'
};

export default translations;
